export const WEEK_TIME_GAP = 1000 * 60 * 60 * 24 * 7;
